/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import style from './SolutionCell.scss';

/** Components */
import SolutionModal from './SolutionModal';

class SolutionCell extends Component {
  render() {
    // Somtimes solution is null; return an empty cell
    if (!this.props.solution || !this.props.solution.solution) {
      return <th>-</th>;
    }

    const solution = this.props.solution.solution;

    // Determine what type of solution this is
    const isVideo = _.has(solution, 'video');
    const isImage = !isVideo && solution.explanation.indexOf('<img') !== -1;

    // TODO: these other classes need updated
    const solutionClasses = classNames({
      [style.indicator]: true,
      text: !isVideo && !isImage,
      [style.video]: isVideo,
      image: isImage,
    });

    return (
      <SolutionModal
        solutionData={this.props.solution}
        question={this.props.question}
        origin={this.props.origin}
        analyticsPayload={this.props.analyticsPayload}
      >
        <div className={solutionClasses} />
      </SolutionModal>
    );
  }
}

export default SolutionCell;
